// @flow

import gql from "graphql-tag";
import { graphql } from "react-apollo";

export type TaskType = {
  id: string,
  question: string,
  answer: boolean,
  responseTimesInSeconds: Array<number>,
  metadata: Object,
  project: {
    id: string,
    name: string,
    template: string
  }
};

// RetrieveTasks
export const retrieveTasksMutation = gql`
  mutation($userId: ID!, $projectId: ID!) {
    retrieveTasks(userId: $userId, projectId: $projectId) {
      tasks
    }
  }
`;

export type retrieveTasksMutationResult = {
  data: {
    retrieveTasks: {
      tasks: Array<TaskType>
    }
  }
};

export const withRetrieveTasks = graphql(retrieveTasksMutation, {
  name: "retrieveTasks"
});

export type RetrieveTasksType = () => Promise<retrieveTasksMutationResult>;



// WEBPACK FOOTER //
// ./src/data/tasks.js